import { CONFIG } from '../config.js';

export function nearestStarDistance(planet, list) {
  let minD = Infinity;
  for (let i = 0; i < list.length; i++) {
    if (!list[i].isStar) continue;
    const d = planet.position.distanceTo(list[i].position);
    if (d < minD) minD = d;
  }
  return minD;
}

export function planetTemperature(planet, list, config = CONFIG) {
  const d = Math.max(nearestStarDistance(planet, list), config.D_FLOOR);
  const T = config.T0 * Math.sqrt(config.D_REF / d);
  return Math.min(config.T_MAX, Math.max(config.T_MIN, T));
}

export function civilizationStatus(T, config = CONFIG) {
  if (T > config.SCORCHING_T) return { key: 'scorching', label: '炎热' };
  if (T < config.FREEZING_T) return { key: 'freezing', label: '极寒' };
  return { key: 'stable', label: '恒纪元' };
}

export function starTemperature(mass) {
  return 4000 + 2000 * ((mass - 0.8) / 0.7);
}

export function spectralType(T) {
  if (T < 3700) return 'M';
  if (T < 5200) return 'K';
  if (T < 6000) return 'G';
  return 'F';
}

export function relativeLuminosity(mass) {
  return Math.pow(mass, 3.5);
}
